<template>
  <div id="mainSlider1" class="slider-animation-fast a-vs-header--main-slider">
    <div class="slides-container">
        <div class="wrapper">
          <transition name="slide">
            <jackpot-info-champion-slide
              v-if="isSlideVisible(1)"
              :amount="championJackpotAmount"
              :currency="currency" />
          </transition>
        </div>
        <div class="wrapper">
          <transition name="slide">
            <jackpot-info-stadium-slide
              v-if="isSlideVisible(2)"
              :totalOdds="totalOdds"
              :amount="stadiumJackpotAmount"
              :currency="currency" />
            </transition>
        </div>
        <div class="wrapper">
          <transition name='slide'>
            <jackpot-info-winning-champion-slide
              v-if="isSlideVisible(3)"
              :winningJackpots="WinningJackpotsChampion"
              :currency="currency" />
          </transition>
        </div>
        <!-- Last three stadium jackpots -->
        <div class="wrapper">
          <transition name="slide">
            <jackpot-info-winning-stadium-slide
              v-if="isSlideVisible(4)"
              :winningJackpots="WinningJackpotsStadium"
              :currency="currency" />
          </transition>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/soccer/api.service.network.js'
import NumberFormat from '@/mixins/NumberFormat'
import { eventBus } from '@/main.js'

import JackpotsInfoChampionSlide from '@/components/soccer/slides/JackpotsInfoChampionSlide.vue'
import JackpotsInfoStadiumSlide from '@/components/soccer/slides/JackpotsInfoStadiumSlide.vue'
import JackpotsInfoWinningChampionSlide from '@/components/soccer/slides/JackpotsInfoWinningChampionSlide.vue'
import JackpotsInfoWinningStadiumSlide from '@/components/soccer/slides/JackpotsInfoWinningStadiumSlide.vue'
import LanguageHelper from '@/mixins/LanguageHelper'

import vuexStore from '../../../store/vuexStore'

import mainTheme from '../../../assets/audio/vSoccer/main_theme.mp3'

export default {
  components: {
    'jackpot-info-champion-slide': JackpotsInfoChampionSlide,
    'jackpot-info-stadium-slide': JackpotsInfoStadiumSlide,
    'jackpot-info-winning-champion-slide': JackpotsInfoWinningChampionSlide,
    'jackpot-info-winning-stadium-slide': JackpotsInfoWinningStadiumSlide
  },
  mixins: [NumberFormat, LanguageHelper],
  props: {
    currency: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      slideOrder: [],
      Jackpots: [],
      ChampionJackpot: [],
      StadiumJackpot: [],
      WinningJackpotsChampion: [],
      WinningJackpotsStadium: [],
      showSliderPosition: 0,
      numberOfSlides: 4,
      sliderTimer: null,
      audio: null,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled,
      jackpotsServiceCallInterval: null,
      countdownTimer: 0
    }
  },
  watch: {
    hasAudioEnabled () {
      if (this.hasAudioEnabled) {
        if (this.audio === null) {
          this.audio = new Audio(mainTheme)
          this.audio.addEventListener('ended', function () {
            this.currentTime = 0
            this.play()
          }, false)
          this.audio.play()
        }
      } else {
        if (this.audio !== null) {
          this.audio.pause()
          this.audio = null
        }
      }
    }
  },
  mounted: function () {
    if (this.hasAudioEnabled) {
      if (this.audio === null) {
        this.audio = new Audio(mainTheme)
        this.audio.addEventListener('ended', function () {
          this.currentTime = 0
          this.play()
        }, false)
        this.audio.play()
      }
    } else {
      if (this.audio !== null) {
        this.audio.pause()
        this.audio = null
      }
    }
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
    this.jackpotsServiceCallInterval = setInterval(() => {
      if (this.countdownTimer >= 5) {
        this.computeJackpots()
      }
    }, vuexStore.state.randomGeneratedJackpotInterval * 1000)
  },
  created: function () {
    eventBus.$on('vsoccer_timer_tick', (data) => {
      this.countdownTimer = data
    })
    this.computeJackpots()
  },
  computed: {
    totalOdds: function () {
      if (this.StadiumJackpot && this.StadiumJackpot.length > 0) {
        return this.formatNumber((this.StadiumJackpot[0].JackpotPrerequisite / 100), this.getLanguageCodeForNumbers())
      }
      return ''
    },
    championJackpotAmount: function () {
      if (this.ChampionJackpot && this.ChampionJackpot.length > 0) {
        return this.ChampionJackpot[0].Amount
      }
      return '0'
    },
    stadiumJackpotAmount: function () {
      if (this.StadiumJackpot && this.StadiumJackpot.length > 0) {
        return this.StadiumJackpot[0].Amount
      }
      return '0'
    }
  },
  methods: {
    computeJackpots: function () {
      api.getJackpot().subscribe(data => {
        this.Jackpots = data.jackpots
        this.ChampionJackpot = data.championJackpot
        this.StadiumJackpot = data.stadiumJackpot
        this.WinningJackpotsChampion = data.winningJackpotsChampion
        this.WinningJackpotsStadium = data.winningJackpotsStadium

        if (this.StadiumJackpot && this.StadiumJackpot.length > 0) {
          this.slideOrder.push(1)
        }
        if (this.ChampionJackpot && this.ChampionJackpot.length > 0) {
          this.slideOrder.push(2)
        }
        if (this.WinningJackpotsStadium && this.WinningJackpotsStadium.length > 0) {
          this.slideOrder.push(3)
        }
        if (this.WinningJackpotsChampion && this.WinningJackpotsChampion.length > 0) {
          this.slideOrder.push(4)
        }
        this.showSlides(true)
      }, eventBus.onApiError)
    },
    isSlideVisible: function (slide) {
      return this.slideOrder[this.showSliderPosition] === slide
    },
    nextSlide () {
      this.showSliderPosition = ((this.showSliderPosition + 1) % this.slideOrder.length)
    },
    showSlides (ignoreNextSlide) {
      if (!ignoreNextSlide) {
        this.nextSlide()
      }
      if (this.sliderTimer) {
        clearInterval(this.sliderTimer)
      }
      this.sliderTimer = setInterval(() => {
        this.nextSlide()
      }, 10 * 1000)
    }
  },
  beforeDestroy () {
    clearInterval(this.sliderTimer)
    if (this.jackpotsServiceCallInterval !== null) {
      clearInterval(this.jackpotsServiceCallInterval)
    }
  },
  destroyed () {
    if (this.audio !== null) {
      this.audio.pause()
      this.audio = null
    }
  }
}
</script>
